import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ShipmentFilterState {
  appliedFilters: unknown[];
  isSearchVisible: boolean;
  searchQuery: string;
  appliedSearchQuery: string;
  activeViewType: 'list' | 'calendar';
  activeLegType: 'CL' | 'EL';
  filterArray?: unknown[];
  progressFiltersByLeg?: unknown;
}

interface SetFilterPayload {
  appliedFilters?: unknown[];
  filterArray?: unknown[];
  searchQuery?: string;
  appliedSearchQuery?: string;
  activeViewType?: 'list' | 'calendar';
  activeLegType?: 'CL' | 'EL';
  isSearchVisible?: boolean;
  progressFiltersByLeg?: unknown;
}

interface RootState {
  shipmentFilter: ShipmentFilterState;
  [key: string]: unknown;
}

const initialShipmentFilterState: ShipmentFilterState = {
  appliedFilters: [],
  isSearchVisible: false,
  searchQuery: '',
  appliedSearchQuery: '',
  activeViewType: 'list',
  activeLegType: 'CL',
  filterArray: [],
};

const shipmentFilterSlice = createSlice({
  name: 'shipmentFilter',
  initialState: initialShipmentFilterState,
  reducers: {
    setshipmentFilterState: (
      state,
      action: PayloadAction<SetFilterPayload>
    ) => {
      const payload = action.payload;

      if (payload.appliedFilters !== undefined) {
        state.appliedFilters = payload.appliedFilters;
      }

      if (payload.filterArray !== undefined) {
        state.filterArray = payload.filterArray;
      }

      if (payload.searchQuery !== undefined) {
        state.searchQuery = payload.searchQuery;
      }

      if (payload.appliedSearchQuery !== undefined) {
        state.appliedSearchQuery = payload.appliedSearchQuery;
      }

      if (payload.activeViewType !== undefined) {
        state.activeViewType = payload.activeViewType;
      }

      if (payload.activeLegType !== undefined) {
        state.activeLegType = payload.activeLegType;
      }

      if (payload.isSearchVisible !== undefined) {
        state.isSearchVisible = payload.isSearchVisible;
      }

      if (payload.progressFiltersByLeg !== undefined) {
        state.progressFiltersByLeg = payload.progressFiltersByLeg;
      }
    },
  },
});

export const { setshipmentFilterState } = shipmentFilterSlice.actions;

export const selectShipmentFilterState = (state: RootState) =>
  state.shipmentFilter;

export const shipmentFilterReducer = shipmentFilterSlice.reducer;
